import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { ResponsesPageables } from "../../core/models/responesPageables";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class QueryFilesPlacaService {
  env = environment.env;
  admDatosURL = endpointsURL.admDatosURL;

  constructor(private httpClient: HttpClient) {}

  public getQueryFilesPlacaList(
    filters: string
  ): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.admDatosURL}edit/lista${filters}`
    );
  }

  public getDownloadFile(idFile: string) {
    let params = new HttpParams().set("_identificador", idFile);
    return this.httpClient.get(
      `${this.env}${this.admDatosURL}download/idFichero`,
      {
        params: params,
        responseType: "blob",
      }
    );
  }
  public getFileGeneration() {
    return this.httpClient.get(
      `${this.env}${this.admDatosURL}edit/printerFileGeneration`
    );
  }
}
